import { shade } from 'polished';
import styled, { ThemeColors } from 'styled-components';

export interface ButtonProps {
    main?: boolean;
    accent?: boolean;
    attention?: boolean;
    height?: number;
    bgColor?: keyof ThemeColors;
    color?: keyof ThemeColors;
    pill?: boolean;
    uppercase?: boolean;
    fullwidth?: boolean;
    fontSize?: string;
    disabled?: boolean;
    rounded?: boolean;
    border?: boolean;
    flex?: boolean;
}

const Button = styled.button<ButtonProps>`
    cursor: pointer;
    position: relative;
    border: ${({ border, theme }) => (border ? `1px solid ${theme.colors.text}` : 'none')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '15px')};
    text-transform: ${({ uppercase }) => (uppercase ? 'uppercase' : 'inherit')};
    width: ${({ fullwidth: isFullWidth }) => (isFullWidth ? '100%' : 'auto')};
    padding: 0 1rem;
    white-space: nowrap;
    transition: opacity 0.3s ease, background-color 0.3s ease;
    height: ${({ height }) => (height ? height + 'px' : '35px')};
    line-height: ${({ height }) => (height ? height + 'px' : '35px')};

    ${({ flex }) => (flex ? 'display: flex; align-items: center; justify-content: center; gap: 0.5rem;' : '')}

    color: ${({ theme, main, accent, attention, color, disabled }) => {
        if (disabled) return theme.colors.textDisabled;
        if (color) return theme.colors[color];
        if (attention) return theme.colors.attentionText;
        if (accent) return theme.colors.accentText;
        if (main) return theme.colors.mainText;
        return theme.colors.text;
    }} !important;

    background-color: ${(props) => getBgColor(props, props.theme.colors)};
    border-radius: ${({ rounded, pill, height }) => {
        if (rounded) return 'var(--radius)';
        if (pill) return `${height ? height / 2 : 17.5}px`;
        return '2px';
    }};

    > a {
        color: #fff;
    }

    &:disabled {
        color: ${({ theme }) => theme.colors.textDisabled} !important;
    }

    ${(props) =>
        !props.disabled
            ? `
    &:hover {
      background-color: ${shade(0.03, getBgColor(props, props.theme.colors))};
    }
  `
            : ''}
`;

function getBgColor(props: ButtonProps, themeColors: ThemeColors) {
    const { bgColor, attention, accent, main, disabled } = props;
    if (disabled) return themeColors.disabled;
    if (bgColor) return themeColors[bgColor];
    if (attention) return themeColors.attention;
    if (accent) return themeColors.accent;
    if (main) return themeColors.main;
    return themeColors.fill;
}

export default Button;
